import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import './CuratorCountDisplay.scss';

import { getPrettyNumber } from '../../../Helpers/formatting';

import Tooltip from '../../General/Tooltip';

const CuratorCountDisplay = props => {
  const { count, circleCount, onClick, curators, circleCurators } = props;

  // Figure out which images to show
  const NUM_IMAGES_TO_SHOW = 3;
  const curatorsWithImages = _.concat(curators || [], circleCurators || []).filter(c => c.image);

  return (
    <div onClick={onClick} className={cn('curator-count-display-container')}>
      <div className='display-images'>
        {curatorsWithImages.slice(0, NUM_IMAGES_TO_SHOW).map(c => (
          <Tooltip key={c.id} message={c.name}>
            <img src={c.image} alt={c.name} />
          </Tooltip>
        ))}
      </div>
      <div className={cn('display-text', { clickable: !!onClick })}>
        {circleCount > 0
          ? `Shared by ${getPrettyNumber(count)} curator${count === 1 ? '' : 's'}, ${getPrettyNumber(circleCount)} in your circles`
          : `Shared by ${getPrettyNumber(count)} curator${count === 1 ? '' : 's'}`}
      </div>
    </div>
  );
};

CuratorCountDisplay.propTypes = {
  count: PropTypes.number.isRequired,
  circleCount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  curators: PropTypes.array.isRequired,
  circleCurators: PropTypes.array
};

export default CuratorCountDisplay;
